// property-card.component.ts
import {Component, Input, Output, EventEmitter} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CurrencyPipe} from "@angular/common";

@Component({
  selector: 'app-property-card',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="property active" style="cursor: pointer;" (click)="onCardClick()">
      <!-- Featured Image Section -->
      <div class="featured-image"
           [ngStyle]="{ 'background-image': 'url(' + listing.listingMedia.data[0].url + ')'}">
        <div *ngIf="listing.banner"
             [class]="listing.banner.bannerClass"
             class="banner">
          <div [class]="listing.banner.lineClass"
               [innerHTML]="listing.banner.text">
          </div>
        </div>
      </div>

      <!-- Content Section -->
      <div class="content">
        <!-- Price Row -->
        <div class="row">
          <div class="price">
            {{ formatPrice(listing.listingPrice) }}
            <span *ngIf="isRental">per week</span>
          </div>
        </div>

        <!-- Description Row -->
        <div class="row">
          <p class="description">
            <span class="sold" *ngIf="isSoldNotExclusive">{{ listing.listingStatus }}</span>
            <span class="exclusive" *ngIf="listing.exclusive">Exclusive</span>
            {{ listing.listingDetail?.address }}
          </p>
        </div>

        <!-- Property Features Row -->
        <div *ngIf="!isRental && listing.squareFootage && listing.squareFootage!=='0'" class="row">
          <p class="feet">{{ listing.squareFootage }} Sq. Ft.</p>
        </div>
        <div *ngIf="isRental && listing.listingDetail?.numBeds" class="row">
          <p class="feet">{{ listing.listingDetail?.numBeds }} Bedrooms</p>
        </div>
        <div *ngIf="isRental && listing.bathroomsTotal" class="row">
          <p class="feet">{{ listing.bathroomsTotal }} Bathrooms</p>
        </div>

        <!-- Links Row -->
        <div class="row">
          <ul class="links">
            <li *ngIf="listing.listingDetail?.virtualTour">
              <a href="{{listing.listingDetail?.virtualTour}}" target="_blank">Virtual Tour</a>
            </li>
            <li *ngIf="listing.listingDetail?.brochureLink">
              <a href="{{listing.listingDetail?.brochureLink}}" target="_blank">Brochure</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  `
})
export class PropertyCardComponent {
  @Input() listing: any;
  @Output() cardClick = new EventEmitter<any>();

  constructor(private currencyPipe: CurrencyPipe) {
  }

  get isRental(): boolean {
    return (this.listing.listingStatus?.toLowerCase() === 'rental');
  }

  get isSoldNotExclusive(): boolean {
    return (this.listing.listingStatus?.toLowerCase() === 'sold' && !this.listing.exclusive);
  }

  formatPrice(price: number): string {
    return this.currencyPipe.transform(price, '', 'symbol', '1.0-0') || '';
  }

  onCardClick(): void {
    this.cardClick.emit(this.listing);
  }
}
